// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-subtitle{margin-right:5px;margin-top:-15px}.search-button{margin-right:-20px;margin-top:5px}.search-results-count{margin-bottom:-1rem;text-align:right}", ""]);
// Exports
module.exports = exports;
